import React from 'react';
import { DateField } from 'react-admin';

const CustomDateField = props => {
  return <DateField options={{ timeZone: 'Europe/Minsk' }} showTime locales="ru" {...props}/>
};

export default CustomDateField;
